import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App, { preloadRoute } from "@/App";

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Hydratie-strategie:
// - Prerendered pagina's (scripts/prerender.cjs) bevatten de route in
//   window.__PRERENDER_ROUTE__. Alleen als die overeenkomt met het huidige
//   pad hydrateren we de bestaande DOM (geen re-render flash).
// - Niet-prerenderde paden krijgen de home-HTML als SPA-fallback; dan maken
//   we de root leeg en renderen client-side (voorkomt hydration mismatch).
// - Async route-chunks worden vóór hydratie geladen zodat de eerste render
//   synchroon het echte component toont.
const path = window.location.pathname.replace(/\/+$/, "") || "/";
const prerenderRoute = window.__PRERENDER_ROUTE__ || null;
const canHydrate =
  container && container.hasChildNodes() && (!prerenderRoute || prerenderRoute === path);

function boot() {
  if (canHydrate) {
    ReactDOM.hydrateRoot(container, app, {
      onRecoverableError: (err, info) => {
        console.warn("[hydration]", err && err.message, info && info.componentStack);
      },
    });
  } else {
    if (container.hasChildNodes()) container.replaceChildren();
    ReactDOM.createRoot(container).render(app);
  }
}

preloadRoute(path).then(boot, boot);
